import Raphael from 'raphael/raphael';

getDescription = (commit) ->
  commit.messages ?= []
  validCommits = commit.messages.filter(Boolean).slice(0, 1)
  if validCommits.length > 0
    message = validCommits
    if (count = commit.messages.length - validCommits.length) > 0
      message += ", and #{ count } other writes."
    message
  else
    "#{ commit.messages.length } writes."

Raphael.prototype.commitTooltip = (x, y, commit) ->
  boxWidth = 300;
  icon = @image(commit.author.icon, x, y, 20, 20)
  nameText = @text(x + 25, y + 10, commit.author.name)
  idText = @text(x, y + 35, commit.id)
  messageText = @text(x, y + 80, getDescription(commit))
  dateText = @text(x, y + 65, commit.date)
  textSet = @set(icon, nameText, idText, messageText, dateText).attr({
    'text-anchor': 'start',
    font: '12px Monaco, monospace'
  })
  nameText.attr({
    font: '14px Arial',
    'font-weight': 'bold',
  })
  @set(idText, messageText).attr({
    fill: '#AAA',
  })
  messageText.node.style['white-space'] = 'pre'
  @textWrap(messageText, boxWidth - 50)
  rect = @rect(x - 10, y - 10, boxWidth, 100, 4).attr({
    fill: '#FFF',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-width': 2,
  })
  tooltip = @set(rect, textSet)
  rect.attr({
    height: tooltip.getBBox().height + 10,
    width: tooltip.getBBox().width + 10,
  })
  tooltip.transform(['t', 20, 20])
  tooltip

Raphael.prototype.textWrap = (t, width) ->
  content = t.attr('text')
  abc = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  t.attr({
    text: abc
  })
  letterWidth = t.getBBox().width / abc.length
  t.attr({
    text: content,
  })
  words = content.split(' ')
  x = 0
  s = []
  for word in words
    if (x + word.length * letterWidth > width)
      s.push('\n');
      x = 0;

    if (word is '\n')
      s.push('\n')
      x = 0
    else
      s.push("#{word} ")
      x += word.length * letterWidth
  t.attr({
    text: s.join('').trim()
  })
  b = t.getBBox()
  h = Math.abs(b.y2) + 1
  t.attr({
    y: h
  })

export default Raphael
